import { Country } from '../types';
import {
    Destination,
    RoamingRestriction,
} from '../constants';

/* istanbul ignore next */
/**
 * show
 */
export const show = (div: HTMLElement): void => {
    div.style.visibility = 'visible';
    div.style.maxHeight = '2000px';
    div.style.opacity = '1';
    div.style.marginBottom = null;
};

/* istanbul ignore next */
/**
 * hide
 */
export const hide = (div: HTMLElement): void => {
    div.style.visibility = 'hidden';
    div.style.maxHeight = '1px';
    div.style.opacity = '0';
    div.style.marginBottom = '0';
};

/* istanbul ignore next */
/**
 * focus
 */
export const focusDiv = (div: HTMLElement): void => {
    div.scrollIntoView({ block: 'start', behavior: 'smooth' });
};

/**
 * checkIfRoamingIsAllowed
 */
export const checkIfRoamingIsNotAllowed = (
    countries: Array<Country> | boolean,
    selectedCountry: string | boolean,
    destination: Destination | boolean,
): boolean | RoamingRestriction => {
    if (!countries || !selectedCountry || !destination) {
        return false;
    }

    const contriesArray = countries as Array<Country>;

    let canDoRoamingFromHome = contriesArray.find(el => el.countryCode === selectedCountry).roamingOptionHomeCountry;
    let canDoRoamingInForeignCountry = contriesArray.find(el => el.countryCode === selectedCountry).roamingOptionForeignCountry;

    canDoRoamingFromHome = canDoRoamingFromHome === undefined ? true : canDoRoamingFromHome;
    canDoRoamingInForeignCountry = canDoRoamingInForeignCountry === undefined ? true : canDoRoamingInForeignCountry;

    if (destination === Destination.toForeignCountry && !canDoRoamingFromHome) {
        return RoamingRestriction.notInHomeCountry;
    }

    if ((destination === Destination.inForeignCountry || destination === Destination.inForeignCountrySmartDevice)
            && !canDoRoamingInForeignCountry
    ) {
        return RoamingRestriction.notInForeignCountry;
    }

    return false;
};
